
import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star, X } from "lucide-react";

const reviews = [
  {
    id: 1,
    name: "سارة العتيبي",
    rating: 5,
    text: "تعامل احترافي جدًا، فهموا مشروعي من أول مرة وسووا لي خطة تسويق رفعت المبيعات بشكل واضح خلال أول شهر.",
    service: "خدمات تسويق رقمي",
    avatar: "https://imgg.io/images/2025/12/16/a8d4ebcccecf0b7885f32d090a7c3ee0.png"
  },
  {
    id: 2,
    name: "محمد القحطاني",
    rating: 5,
    text: "فريق زان ساعدني أطلق مشروعي رقميًا من الصفر، من الهوية إلى الإعلانات، والنتائج كانت أفضل من المتوقع.",
    service: "استشارات وتسويق شامل",
    avatar: "https://imgg.io/images/2025/12/16/a8d4ebcccecf0b7885f32d090a7c3ee0.png"
  },
  {
    id: 3,
    name: "نوف السبيعي",
    rating: 4,
    text: "شغلهم منظم وواضح، والتواصل ممتاز. لاحظت فرق كبير في التفاعل بعد الحملات التسويقية.",
    service: "تحسين تفاعل العملاء",
    avatar: "https://imgg.io/images/2025/12/16/a8d4ebcccecf0b7885f32d090a7c3ee0.png"
  },
  {
    id: 4,
    name: "عبدالله المطيري",
    rating: 5,
    text: "تعامل راقٍ والتزام بالمواعيد، والأهم إنهم يشتغلون على أهداف حقيقية مو كلام تسويق فقط.",
    service: "إدارة الحملات الإعلانية",
    avatar: "https://imgg.io/images/2025/12/16/a8d4ebcccecf0b7885f32d090a7c3ee0.png"
  },
  {
    id: 5,
    name: "ريم الحربي",
    rating: 5,
    text: "أكثر شي عجبني إنهم يهتمون بالتفاصيل الصغيرة، من المحتوى إلى التصميم والإعلانات.",
    service: "هوية بصرية وتصميم",
    avatar: "https://imgg.io/images/2025/12/16/a8d4ebcccecf0b7885f32d090a7c3ee0.png"
  },
  {
    id: 6,
    name: "خالد الزهراني",
    rating: 4,
    text: "تجربة ممتازة بشكل عام، النتائج كانت واضحة خاصة في الإعلانات الممولة وبناء الهوية.",
    service: "تحليل وتطوير أداء الحملات",
    avatar: "https://imgg.io/images/2025/12/16/a8d4ebcccecf0b7885f32d090a7c3ee0.png"
  },
  {
    id: 7,
    name: "سلمان العبدالله",
    rating: 5,
    text: "أحببت طريقة تقديمهم للخدمات، كل شيء كان واضح ومنظم، والنصائح كانت عملية وفعّالة.",
    service: "استراتيجيات تسويق مبتكرة",
    avatar: "https://imgg.io/images/2025/12/16/a8d4ebcccecf0b7885f32d090a7c3ee0.png"
  },
  {
    id: 8,
    name: "منى القحطاني",
    rating: 4,
    text: "نتائج رائعة خلال الأسابيع الأولى، فريق محترف ويعرف كيف يوصل الفكرة للعميل.",
    service: "إدارة محتوى رقمي",
    avatar: "https://imgg.io/images/2025/12/16/a8d4ebcccecf0b7885f32d090a7c3ee0.png"
  },
  {
    id: 9,
    name: "عبدالعزيز الشهراني",
    rating: 5,
    text: "أفضل تجربة تسويقية مررت بها، اهتمام بالتفاصيل وتنفيذ سريع وفعال.",
    service: "تسويق شامل للمشاريع الصغيرة",
    avatar: "https://imgg.io/images/2025/12/16/a8d4ebcccecf0b7885f32d090a7c3ee0.png"
  },
  {
    id: 10,
    name: "سلمى الحربي",
    rating: 5,
    text: "محترفون جدًا، النتائج كانت ملموسة وواضحة، أحببت طريقة العمل معهم من البداية للنهاية.",
    service: "خدمات تسويق رقمي متكاملة",
    avatar: "https://imgg.io/images/2025/12/16/a8d4ebcccecf0b7885f32d090a7c3ee0.png"
  }
];


export default function ReviewWidget() {
  const [currentReview, setCurrentReview] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [imageErrors, setImageErrors] = useState({});
  const [isManuallyDismissed, setIsManuallyDismissed] = useState(
    () => sessionStorage.getItem('reviewWidgetDismissed') === 'true'
  );

  useEffect(() => {
    if (isManuallyDismissed) return;

    const showWidget = () => {
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };

    const interval = setInterval(() => {
      setCurrentReview((prev) => (prev + 1) % reviews.length);
      showWidget();
    }, 8000);

    const initialTimer = setTimeout(() => {
      showWidget();
    }, 3000);

    return () => {
      clearInterval(interval);
      clearTimeout(initialTimer);
    };
  }, [isManuallyDismissed]);

  const handleDismiss = () => {
    setIsVisible(false);
    setIsManuallyDismissed(true);
    sessionStorage.setItem('reviewWidgetDismissed', 'true');
  };

  const handleImageError = (reviewId) => {
    setImageErrors(prev => ({ ...prev, [reviewId]: true }));
  };

  const review = reviews[currentReview];

  return (
    <AnimatePresence>
      {!isManuallyDismissed && isVisible && (
        <motion.div
          initial={{ opacity: 0, x: -100, scale: 0.8 }}
          animate={{ opacity: 1, x: 0, scale: 1 }}
          exit={{ opacity: 0, x: -100, scale: 0.8 }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          className="font-cairo fixed bottom-2 left-2 z-50 w-56 xs:w-60 sm:w-64 md:w-72"
        >
          <div className="bg-white rounded-xl shadow-2xl border border-gray-100 p-3 sm:p-4 relative overflow-hidden">
            {/* Gradient Background */}
            <div className="absolute inset-0 bg-gradient-to-br from-[#141d3c]/5 via-white to-[#ee9805]/5" />
            
            {/* Close Button */}
            <button
              onClick={handleDismiss}
              className="absolute top-1 right-1 w-5 h-5 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center transition-colors duration-200 z-10"
            >
              <X className="w-3 h-3 text-gray-500" />
            </button>

            {/* Content */}
            <div className="relative">
              {/* Header */}
              <div className="flex items-center gap-2 mb-2">
                <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full overflow-hidden border-2 border-[#141d3c]/20 flex-shrink-0 bg-gray-100">
                  {imageErrors[review.id] ? (
                    <div className="font-cairo w-full h-full bg-gradient-to-br from-[#141d3c] to-[#ee9805] flex items-center justify-center">
                      <span className="text-white font-semibold text-xs">{review.name.charAt(0)}</span>
                    </div>
                  ) : (
                    <img
                      src={review.avatar}
                      alt={review.name}
                      className="w-full h-full object-cover"
                      onError={() => handleImageError(review.id)}
                    />
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-cairo text-sm font-semibold text-[#0F0F0F] truncate">
                    {review.name}
                  </p>
                  <div className="flex gap-0.5">
                    {[...Array(5)].map((_, i) => (
                      <Star
                        key={i}
                        className={`w-3 h-3 ${
                          i < review.rating
                            ? 'text-[#141d3c] fill-current'
                            : 'text-gray-300'
                        }`}
                      />
                    ))}
                  </div>
                </div>
              </div>

              <p className="font-cairo text-[10px] sm:text-[11px] text-gray-600 leading-tight mb-2 line-clamp-2 pr-4">
  "{review.text}"
</p>

              {/* Service */}
              <div className="inline-block bg-[#141d3c]/10 text-[#141d3c] px-2 py-1 rounded-full text-xs font-medium">
                {review.service}
              </div>
            </div>

            {/* Pulse Animation Border */}
            <div className="absolute inset-0 rounded-xl border-2 border-[#141d3c]/30 animate-pulse pointer-events-none" />
          </div>

          {/* SERENITY Badge */}
          <div className="absolute -top-1 -right-1 bg-[#141d3c] text-white px-2 py-0.5 rounded-full text-xs font-medium shadow-lg">
            ZAN DIGITAL MARKETING
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
